import { useState } from 'react';
import {
  Container,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Box,
  Button,
  Rating,
  Chip,
  Stack,
  TextField,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Search, MapPin, Phone, Mail, Star } from 'lucide-react';
import { mockAgents as agents } from '../utils/mockData'; // CORRECT PATH

const AgentsPage = () => {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredAgents = agents.filter(agent =>
    agent.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    agent.location.toLowerCase().includes(searchQuery.toLowerCase()) ||
    agent.specialties.some(s => s.toLowerCase().includes(searchQuery.toLowerCase()))
  );

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Box sx={{ mb: 6, textAlign: 'center' }}>
        <Typography variant="h3" component="h1" gutterBottom fontWeight={700}>
          Our Real Estate Agents
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
          Find experienced agents to help you find your perfect home
        </Typography>
        
        <TextField
          fullWidth
          placeholder="Search agents by name, location, or specialty..."
          variant="outlined"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          sx={{ maxWidth: 600 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <Grid container spacing={4}>
        {filteredAgents.map((agent) => (
          <Grid item xs={12} sm={6} md={4} key={agent.id}>
            <RouterLink to={`/agents/${agent.id}`} style={{ textDecoration: 'none', display: 'block', height: '100%' }}>
              <Card
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'transform 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 6, 
                  },
                }}
              >
                <CardMedia
                  component="img"
                height="240"
                image={agent.image}
                alt={agent.name}
                sx={{ objectFit: 'cover' }}
              />
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="h6" gutterBottom>
                  {agent.name}
                </Typography>
                <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                  {agent.title}
                </Typography>
                
                <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
                  <Rating value={agent.rating} precision={0.1} readOnly size="small" />
                  <Typography variant="body2" color="text.secondary">
                    ({agent.reviews} reviews)
                  </Typography>
                </Stack>

                <Box sx={{ mb: 2 }}>
                  <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <MapPin size={16} style={{ marginRight: 8 }} />
                    {agent.location}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {agent.listings} active listings • {agent.experience} experience
                  </Typography>
                </Box>

                <Box sx={{ mb: 2 }}>
                  {agent.specialties.map((specialty) => (
                    <Chip
                      key={specialty}
                      label={specialty}
                      size="small"
                      sx={{ mr: 1, mb: 1 }}
                    />
                  ))}
                </Box>

                <Stack spacing={2}>
                  <Button
                    variant="contained"
                    fullWidth
                    startIcon={<Phone size={16} />}
                    href={`tel:${agent.phone}`}
                  >
                    Call
                  </Button>
                  <Button
                    variant="outlined"
                    fullWidth
                    startIcon={<Mail size={16} />}
                    href={`mailto:${agent.email}`}
                  >
                    Email
                  </Button>
                </Stack>
              </CardContent>
            </Card>
            </RouterLink>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default AgentsPage;